import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../../utils/TestIds';
import { DEFAULT_EMPTY_TEXT } from '../../table.constants';
import { BadgeCell } from '../BadgeCell/BadgeCell';
import { CellAdornments } from '../CellAdornments/CellAdornments';
import { asStringList } from '../cellValues';
import { CheckCell } from '../CheckCell/CheckCell';
import { DateCell } from '../DateCell/DateCell';
import { EditableCell } from '../EditableCell/EditableCell';
import { IdentityCell } from '../IdentityCell/IdentityCell';
import { LinkCell } from '../LinkCell/LinkCell';
import { ListCell } from '../ListCell/ListCell';
import { MoneyCell } from '../MoneyCell/MoneyCell';
import { MultiSelectCell } from '../MultiSelectCell/MultiSelectCell';
import { SelectCell } from '../SelectCell/SelectCell';
import { TagChips } from '../TagChips/TagChips';
import { TextCell } from '../TextCell/TextCell';
import { ToggleCell } from '../ToggleCell/ToggleCell';
import { semanticSkinOnly, tableWeight } from './SchemaCell.utils';
function CellBody(param) {
    let { column, row, now, skin, weight, editing, edit, testId } = param;
    var _column_skin;
    const value = row[column.name];
    // WHY: a blank emptyText is not a way to render nothing; only a word naming an actionable state replaces the glyph.
    const emptyText = column.emptyText || DEFAULT_EMPTY_TEXT;
    const textSkin = skin !== null && skin !== void 0 ? skin : semanticSkinOnly((_column_skin = column.skin) === null || _column_skin === void 0 ? void 0 : _column_skin.call(column, row));
    const textWeight = tableWeight(weight !== null && weight !== void 0 ? weight : column.weight);
    switch(column.type){
        case 'text':
            var _column_subtitle, _column_badge, _column_dotColor, _column_required;
            return /*#__PURE__*/ _jsx(TextCell, {
                textSkin: textSkin,
                textWeight: textWeight,
                value: value,
                subtitle: (_column_subtitle = column.subtitle) === null || _column_subtitle === void 0 ? void 0 : _column_subtitle.call(column, row),
                badge: (_column_badge = column.badge) === null || _column_badge === void 0 ? void 0 : _column_badge.call(column, row),
                multiline: column.multiline,
                dotColor: (_column_dotColor = column.dotColor) === null || _column_dotColor === void 0 ? void 0 : _column_dotColor.call(column, row),
                required: ((_column_required = column.required) === null || _column_required === void 0 ? void 0 : _column_required.call(column, row)) === true,
                tokens: column.tokens,
                emptyText: emptyText,
                editing: editing,
                testId: testId
            });
        case 'badge':
            {
                var _ref;
                var _column_useColor, _column_useInfo;
                const badge = typeof value === 'string' ? value : '';
                return /*#__PURE__*/ _jsx(BadgeCell, {
                    value: badge,
                    skin: (_ref = (_column_useColor = column.useColor) === null || _column_useColor === void 0 ? void 0 : _column_useColor.call(column, badge)) !== null && _ref !== void 0 ? _ref : 'default',
                    info: (_column_useInfo = column.useInfo) === null || _column_useInfo === void 0 ? void 0 : _column_useInfo.call(column, badge, row),
                    testId: testId
                });
            }
        case 'date':
            var _column_format;
            return /*#__PURE__*/ _jsx(DateCell, {
                textSkin: textSkin,
                value: value,
                format: (_column_format = column.format) !== null && _column_format !== void 0 ? _column_format : 'date',
                now: now,
                emptyText: emptyText,
                testId: testId
            });
        case 'money':
            var _column_unit;
            return /*#__PURE__*/ _jsx(MoneyCell, {
                value: value,
                unit: (_column_unit = column.unit) === null || _column_unit === void 0 ? void 0 : _column_unit.call(column, row),
                openRangeText: column.openRangeText,
                emptyText: emptyText,
                textSkin: textSkin,
                edit: edit,
                testId: testId
            });
        case 'list':
            return /*#__PURE__*/ _jsx(ListCell, {
                value: value,
                emptyText: emptyText,
                useBadgeColor: column.useBadgeColor,
                testId: testId
            });
        case 'tags':
            return /*#__PURE__*/ _jsx(TagChips, {
                value: value,
                emptyText: emptyText,
                testId: testId
            });
        case 'check':
            return /*#__PURE__*/ _jsx(CheckCell, {
                value: value,
                testId: testId
            });
        case 'toggle':
            var _column_disabled, _column_loading, _column_tooltip;
            return /*#__PURE__*/ _jsx(ToggleCell, {
                checked: !!value,
                disabled: !!((_column_disabled = column.disabled) === null || _column_disabled === void 0 ? void 0 : _column_disabled.call(column, row)),
                loading: !!((_column_loading = column.loading) === null || _column_loading === void 0 ? void 0 : _column_loading.call(column, row)),
                tooltip: (_column_tooltip = column.tooltip) === null || _column_tooltip === void 0 ? void 0 : _column_tooltip.call(column, row),
                intent: column.intent,
                bi: column.toggleBi,
                onChange: (next)=>editing === null || editing === void 0 ? void 0 : editing.onCommit(next),
                testId: testId
            });
        case 'link':
            return /*#__PURE__*/ _jsx(LinkCell, {
                value: value,
                emptyText: emptyText,
                testId: testId
            });
        case 'identity':
            return /*#__PURE__*/ _jsx(IdentityCell, {
                value: value,
                emptyText: emptyText,
                nameWeight: textWeight,
                testId: testId
            });
        case 'select':
            var _column_disabled1, _column_error;
            return /*#__PURE__*/ _jsx(SelectCell, {
                value: typeof value === 'string' && value !== '' ? value : null,
                onSelect: (next)=>editing === null || editing === void 0 ? void 0 : editing.onCommit(next),
                options: column.options(row),
                emptySearchText: typeof column.emptySearchText === 'function' ? column.emptySearchText(row) : column.emptySearchText,
                placeholder: column.placeholder,
                disabled: !!((_column_disabled1 = column.disabled) === null || _column_disabled1 === void 0 ? void 0 : _column_disabled1.call(column, row)),
                disableClearable: column.disableClearable,
                error: !!((_column_error = column.error) === null || _column_error === void 0 ? void 0 : _column_error.call(column, row)),
                bi: column.selectBi,
                testId: testId
            });
        case 'multiSelect':
            return /*#__PURE__*/ _jsx(MultiSelectCell, {
                value: asStringList(value),
                onSelect: (next)=>editing === null || editing === void 0 ? void 0 : editing.onCommit(next),
                options: column.options(row),
                emptySearchText: typeof column.emptySearchText === 'function' ? column.emptySearchText(row) : column.emptySearchText,
                placeholder: column.placeholder,
                bi: column.selectBi,
                testId: testId
            });
        default:
            return null;
    }
}
export function SchemaCell(props) {
    const { column, row, editing, pending, testId } = props;
    const testIds = getTestIds(testId);
    const onEdit = 'onEdit' in column ? column.onEdit : undefined;
    const onEditBi = 'onEditBi' in column ? column.onEditBi : undefined;
    const isEditable = 'isEditable' in column ? column.isEditable : undefined;
    const editsInPlace = column.type === 'text' && onEdit == null;
    const isAlwaysInteractive = column.type === 'toggle' || column.type === 'select' || column.type === 'multiSelect';
    if (isEditable === true && onEdit != null && onEditBi != null) {
        const edit = {
            bi: onEditBi,
            onEdit: (anchorEl)=>onEdit({
                    row,
                    anchorEl
                }),
            testId: testIds.editTrigger()
        };
        // WHY: a money cell puts only its amount in the box, so it takes the edit rather than being wrapped in it.
        return /*#__PURE__*/ _jsx(CellAdornments, {
            row: row,
            column: column,
            pending: pending,
            testId: testId,
            children: column.type === 'money' ? /*#__PURE__*/ _jsx(CellBody, _object_spread_props(_object_spread({}, props), {
                editing: undefined,
                edit: edit
            })) : /*#__PURE__*/ _jsx(EditableCell, {
                edit: edit,
                children: /*#__PURE__*/ _jsx(CellBody, _object_spread_props(_object_spread({}, props), {
                    editing: undefined
                }))
            })
        });
    }
    return /*#__PURE__*/ _jsx(CellAdornments, {
        row: row,
        column: column,
        pending: pending,
        testId: testId,
        children: /*#__PURE__*/ _jsx(CellBody, _object_spread_props(_object_spread({}, props), {
            editing: isAlwaysInteractive || editsInPlace && isEditable === true ? editing : undefined
        }))
    });
}
